<template>
  <div>
    <!-- KA摊销提示文案 -->
    <div
      v-if="isNeedToCheckKaSupplementAgreement"
      class="copywrite-text"
    >
      感谢您信任并使用美团充电宝的产品和服务，为了更好地为您提供服务，我们对双方已签署的《美团充电宝合作协议》部分条款进行了调整。
    </div>

    <!-- 主体变更提示文案 -->
    <div
      v-if="isNeedToCheckSubjectChangeAgreement"
      class="copywrite-text"
    >
      针对您与美团签署的就充电宝业务达成合作的协议，美团充电宝履约主体需要从
      <span class="blod">“汉海信息技术（上海）有限公司”</span>
      变更为
      <span class="blod">“天津三快信息技术有限公司”</span>
      ，除此之外原合作协议全部内容保持不变。
    </div>

    <!-- 直营续签提示文案 -->
    <div
      v-if="isNeedToCheckRenewCooperationAgreement"
      class="copywrite-text"
    >
      {{ copywriteForCooperationRenew }}
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AgreementApi from '@/api/agreement';
import STATUS from '@/constants/status';

export default {
  name: 'Copywrite',
  data() {
    return {
      copywriteForCooperationRenew: '载入中...',
    };
  },
  computed: {
    ...mapGetters('partnerModule', [
      'isNeedToCheckRenewCooperationAgreement',
      'isNeedToCheckSubjectChangeAgreement',
      'isNeedToCheckKaSupplementAgreement',
    ]),
  },
  created() {
    this.getCopywriteForCooperationRenew();
  },
  methods: {
    async getCopywriteForCooperationRenew() {
      if (!this.isNeedToCheckRenewCooperationAgreement) return;

      try {
        const { respCode, data } = await AgreementApi.getRenewCooperationAgreementInfo() || {};

        if (respCode !== STATUS.SUCCESS) return;

        const { copywriting } = data;
        this.copywriteForCooperationRenew = copywriting;
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$grey1: #666;
$black1: #1A1A1A;

.blod {
  font-weight: bold;
  color: $black1;
}

.copywrite-text {
  font-weight: 400;
  font-family: PingFangSC-Regular;
  font-size: 0.24rem;
  color: $grey1;
  text-align: left;
}
</style>
